import React, {lazy, Suspense} from "react";
import {Redirect, Route, Switch} from "react-router";
import PageLoader from "../../@jumbo/components/PageComponents/PageLoader";

const InteractGroup = ({match}) => {
  const requestedUrl = match.url.replace(/\/$/, "");
  return (
    <Suspense fallback={<PageLoader />}>
      <Switch>
        <Redirect
          exact
          from={`${requestedUrl}/`}
          to={`${requestedUrl}/join-group`}
        />
        <Route
          path={`${requestedUrl}/join-group`}
          component={lazy(() => import("./joinGroup"))}
        />
        <Route
          path={`${requestedUrl}/post-article-group`}
          component={lazy(() => import("./postArticle"))}
        />
        <Route
          path={`${requestedUrl}/invite-join-group`}
          component={lazy(() => import("./inviteJoinGroup"))}
        />
        <Route
          path={`${requestedUrl}/leave-group`}
          component={lazy(() => import("./leaveGroup"))}
        />
        <Route
          path={`${requestedUrl}/like-article-group`}
          component={lazy(() => import("./likeArticleGroup"))}
        />
        <Route
          path={`${requestedUrl}/comment-article-group`}
          component={lazy(() => import("./commentArticleGroup"))}
        />
        <Route
          path={`${requestedUrl}/join-group-private`}
          component={lazy(() => import("./joinGroupPrivate"))}
        />
      </Switch>
    </Suspense>
  );
};

export default InteractGroup;
